import type { GetMyCampaignStatusesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import type { R8CampaignConfig } from "../../../config";
import type { CurrentTime } from "../../../libs/date";
import type { ResidenceCardCapabilityResult } from "../../../libs/sdk";
import type { R8CampaignBannerType } from "./r8-campaign-banner";

export function getR8MiyagiResidenceCardCampaignBannerType(
  campaignStatuses: GetMyCampaignStatusesResponse | null,
  currentTime: CurrentTime,
  isTargetResident: boolean,
  residenceCardCapability: ResidenceCardCapabilityResult,
  config: R8CampaignConfig,
): R8CampaignBannerType {
  if (currentTime.source === "client") {
    return "hidden";
  }

  if (
    currentTime.date < config.startDate ||
    currentTime.date > config.endDate
  ) {
    return "hidden";
  }

  if (!isTargetResident) {
    return "hidden";
  }

  // 正常に取得できた空値だけを再認証へ誘導する。
  // 権限不足などの取得失敗はカードを読み直しても解消しないため非表示にする。
  if (
    residenceCardCapability === "absent" ||
    residenceCardCapability === "unavailable"
  ) {
    return "hidden";
  }

  if (!campaignStatuses) {
    return "hidden";
  }

  if (campaignStatuses.r8MiyagiResidenceCard?.isApplied) {
    return "received";
  }

  return "not-applied";
}
